import { Timestamp } from ".";

declare namespace Schema {
	export interface Blog {
		id: string;
		title: string;
		slug?: string;
		thumbnailUrl: string;
		date: Timestamp;
		excerpt: string;
		categories: Category[];
		outlines?: Outline[];
		createdAt?: Timestamp;
		updatedAt?: Timestamp;
		htmlContent: string;
	}

	export type Category = string;

	export type Outline = {
		heading: string;
		href: string;
	};

	export interface Subscription {
		id: string;
		userId: User["id"];
		note: string;
		type: SubscriptionType;
		price: number;
		startDate: Timestamp;
		endDate: Timestamp;
		status: SubscriptionStatus;
	}

	export interface DomainSubscription extends Subscription {
		plan: DomainSubscriptionPlan;
		domain: string;
	}

	export interface HostingSubscription extends Subscription {
		plan: HostingSubscriptionPlan;
	}

	export interface WebsiteRentalSubscription extends Subscription {
		plan: WebsiteRentalSubscriptionPlan;
		domain: string;
	}

	export interface Customer {
		id: string;
		name: string;
		dob?: Timestamp;
		phone: string;
		email?: string;
		address?: string;
		createdAt: Timestamp;
		updatedAt: Timestamp;
	}

	export interface Product {
		id: string;
		sku: number;
		thumbnailUrl: string;
		photoUrls: string[];
		name: string;
		slug: string;
		price: number;
		stock?: number;
		description?: string;
		categories: string[];
		createdAt: Timestamp;
		updatedAt: Timestamp;
	}

	export interface Item {
		id: string;
		productId: string;
		status: ProductStatus;
		note: string;
	}

	export interface Rental {
		id: string;
		customerId: Customer["id"];
		items: { itemId: Item["id"]; price: number }[];
		deposit: number;
		totalFee: number;
		discountPercent?: number;
		actualPayment: number;
		startDate: Timestamp;
		dueDate: Timestamp;
		returnDate: Timestamp;
		isDone: boolean;
		lostItems: Item["id"][];
		note: string;
		createdBy: User["id"];
		createdAt: Timestamp;
		updatedAt: Timestamp;
	}

	export interface User {
		id: string;
		fullName: string;
		phone: string;
		email: string;
		address?: string;
		username: string;
		password: string;
		photoUrl?: string;
		createdAt: Timestamp;
		updatedAt: Timestamp;
	}

	export interface Report {
		startDate: Timestamp;
		endDate: Timestamp;
		revenue: number;
		income: number;
		deposit: number;
		itemRented: number;
		itemInRent: number;
		itemLost: number;
		refund: number;
		numberOfRentalsByProduct: any;
		rentals: Rental[];
	}
}

export enum ProductStatus {
	AVAILABLE,
	IN_RENT,
	BROKEN,
	LOST
}

export enum SubscriptionType {
	DOMAIN,
	HOSTING,
	WEBSITE_RENTAL,
	GOOGLE_ADS,
	SEO
}

export enum SubscriptionStatus {
	ACTIVE,
	EXPIRED,
	BANNED
}

export enum DomainSubscriptionPlan {
	STANDARD
}

export enum HostingSubscriptionPlan {
	STANDARD
	// TODO: do it later
}

export enum WebsiteRentalSubscriptionPlan {
	STANDARD
	// TODO: do it later
}

export default Schema;
